module.exports = __webpack_public_path__ + "static/media/6.c0aa6738.jpg";